// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"346f87ec","615":"4631b3f3","644":"92993b0b","763":"f9cdebc8","900":"43932899","996":"c9ad3bec"}[chunkId] + ".chunk.js";
};